<script setup lang="ts">
// The platform's logo and name, as 系统设置 sets them: the uploaded logo —
// for a light background and a dark one (the dark theme, or a bar in the
// dark tone), each standing in for the other, the favicon for both while
// there is none — and 系统名称, unless switched off for a logo that carries
// it. mini is the collapsed side menu's: its own logo, no name. A logo of
// any shape keeps the name's height. Size and colour come from where it is
// placed.
import { computed } from 'vue'
import { logos, nameShown, systemName } from '@/utils/branding'

const props = defineProps<{ mini?: boolean }>()
const light = computed(() => (props.mini ? logos.value.miniLight : logos.value.light))
const dark = computed(() => (props.mini ? logos.value.miniDark : logos.value.dark))
const named = computed(() => !props.mini && nameShown.value)
</script>

<template>
  <span class="brand-mark" :class="{ 'brand-mark-solo': !named }">
    <template v-if="light">
      <img v-if="!dark || dark === light" :src="light" alt="" class="brand-logo" />
      <template v-else>
        <img :src="light" alt="" class="brand-logo brand-logo-light" />
        <img :src="dark" alt="" class="brand-logo brand-logo-dark" />
      </template>
    </template>
    <span v-if="named" class="brand-name">{{ systemName }}</span>
  </span>
</template>

<style scoped>
.brand-mark {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.brand-logo {
  flex: none;
  width: auto;
  max-width: 4.8em;
  height: 1.6em;
  object-fit: contain;
}
/* The logo alone carries the name: room for a wordmark. */
.brand-mark-solo .brand-logo {
  max-width: 9em;
}
.brand-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
/* Which of the two shows: the light one, but on a dark background — the
   dark theme, or a bar in the dark tone — the dark one. Unscoped: a scoped
   :global(...) drops whatever follows it. */
.brand-mark .brand-logo-dark {
  display: none;
}
body[arco-theme='dark'] .brand-mark .brand-logo-light,
.tone-dark .brand-mark .brand-logo-light {
  display: none;
}
body[arco-theme='dark'] .brand-mark .brand-logo-dark,
.tone-dark .brand-mark .brand-logo-dark {
  display: block;
}
</style>
